import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PurchaseStyles from "../PurchaseStyles";
import {
    Backdrop,
    Button,
    ButtonGroup,
    CircularProgress,
    FormControl,
    FormHelperText,
    Grid,
    Input,
    InputAdornment,
    InputLabel,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Select,
    Tab,
    Tabs,
} from "@material-ui/core";
import InboxIcon from "@material-ui/icons/Inbox";
import { TabPanel } from "../PurchaseTabPanel";
import UseForm from "../../common/UseForm";
import * as purchaseActions from "../../../actions/purchase/PurchaseActions";
import {
    getOtherInvoiceTableColumnSpa,
    handleGeneralFileTypes,
} from "../../common/Utils";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import { customStyleSecondary } from "../../common/CommonStyles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import PurchaseUploadAccesoryInvoice from "./PurchaseUploadAccesoryInvoice";
import Constants from "../../common/Constants.json";
import CustomSelect from '../../shared/autocomplete.select';

const paginationOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
};
let typeSuggestions0 = [];
let XMLfile;
const PurchaseUploadInvoice = ({ classes, ...props }) => {
    const history = useHistory();
    //P2MSPFE-4482
    const [typeSuggestions, setTypeSuggestions] = useState([]); 
    const [docs, setDocs] = useState([]);
    //P2MSPFE-4482
    const [RFCOrderDoc , setRFCOrderDoc] = useState("");
    const [loading, setLoading] = useState(false);
    const [invoiceTab, setInvoiceTab] = useState(0);
    const [disabledButton, setDisabledButton] = useState(true);
    const [isRight, setIsRight] = useState(false);
    const { t } = useTranslation();
    const [enableFiles, setEnableFiles] = useState(true);
    const [vinNotExist, setVinNotExist] = useState(false);
    const [vinValue, setVinValue] = useState("");
    const [vehKeyValue, setVehKeyValue] = useState("");

    const [arrayJSON, setArrayJSON] = useState([])
    const [disableOptions, setDisableOptions] = useState(true);
    const [hasFiltered, setHasFiltered] = useState(false); //P2MSPFE-4482

    const initialFieldValues = {
        orderId: parseInt(props.orderId),
        isAccessory: false,
        isRight: false,
        rightAmount: 0,
        invoiceType: "",
        documentType: "",
        chargeCode: "",
        paymentType: "",
        pdf: {},
        xml: {},
        right: {},
        invoiceTypeOp: [],
        vinNotExist: false,
        vinValue: "",
        vehKeyValue: "",
    };

    const {
        values,
        handleInputChange,
        handleInputChangeMS,
        handleInpuFileChange,
        errors,
        setErrors,
        resetForm,
        setValues,
    } = UseForm(initialFieldValues);

    useEffect(() => {
        props.purchaseActions.fetch_documents(
            props.userLanguage,
            props.userToken,
            values.orderId,
            onError,
            onSuccessDoc
        );
        props.purchaseActions.fetch_invoice_errors(
            props.userLanguage,
            props.userToken,
            values.orderId,
            onError,
            onSuccessHistory
        );
        props.purchaseActions.getInvoiceTypeOptions(
            props.userLanguage,
            props.userToken,
            values.orderId,
            1,
            onError,
            onSuccessInvoiceType
        );
        props.purchaseActions.getInvoiceTypeOptions(
            props.userLanguage,
            props.userToken,
            values.orderId,
            0,
            onError,
            onSuccessInvoiceType0
        );
        
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //P2MSPFE-4482
    useEffect(() => {
        if (!hasFiltered && typeSuggestions.length > 0 && docs.length > 0 && props.orderDetail.accesories.length > 0) {
            //Quitar Vehiculo
            var arrayTypeSuggestions = typeSuggestions;
            const docsXmls = docs.filter(x => x.documentType === "text/xml");
            docsXmls.forEach(element => {
                if (element.invoiceType === "VE" && element.acceptanceByNvp === true) {
                    const shouldRemoveVE = typeSuggestions.some(inv => inv.label.includes('Vehículo'));
                    arrayTypeSuggestions = shouldRemoveVE ? typeSuggestions.filter(inv => !inv.label.includes('Vehículo')) : typeSuggestions;

                } else if (element.invoiceType === "VE" && element.acceptanceByNvp === false) {
                    const shouldRemoveVE = typeSuggestions.some(inv => inv.value === 'VE');
                    arrayTypeSuggestions = shouldRemoveVE ? typeSuggestions.filter(inv => inv.value !== 'VE') : typeSuggestions;
                }
            });

             
            console.log(arrayTypeSuggestions)
            props.orderDetail.accesories.forEach(element => {
                if (element.accesoryInvoice !== null) {
                    if (element.accesoryInvoice.acceptanceByNvp === true) {
                        console.log(element.description)
                        const shouldRemoveVE = arrayTypeSuggestions.some(inv => inv.label.includes(element.description) && inv.idAddFeat === element.id);
                       arrayTypeSuggestions =shouldRemoveVE ? arrayTypeSuggestions.filter(inv => !(inv.label.includes(element.description) && inv.idAddFeat === element.id)) : arrayTypeSuggestions;
                    }
                }
            });
            setTypeSuggestions(arrayTypeSuggestions);
            setHasFiltered(true);
        }

    }, [docs, typeSuggestions, hasFiltered, props.orderDetail])
    //P2MSPFE-4482

    useEffect(() => {
        if (RFCOrderDoc.length > 0) {
            const result = props.orderDetail.accesories.map(item => {
                if (item.accesoryInvoice !== undefined && item.accesoryInvoice !== null) {
                    if (item.accesoryInvoice.rfcInvoice !== undefined && item.accesoryInvoice.rfcInvoice !== null && item.accesoryInvoice.rfcInvoice.length > 0) {
                        if (RFCOrderDoc !== undefined && RFCOrderDoc !== null && RFCOrderDoc.length > 0) {
                            if (item.accesoryInvoice.rfcInvoice === RFCOrderDoc) {
                                return {...item}
                            }else{
                                return {...item, id:0}
                            }
                        }else{
                            return {...item}
                        }
                    }
                    else{
                        return {...item}
                    }
                }else{
                    return {...item}
                }
            })
            setArrayJSON([])
            const filtered =result.filter(x=>x.id !== 0)
            setArrayJSON(filtered)
        } 
        else
        {
            setArrayJSON([])
            setArrayJSON(props.orderDetail.accesories)
        }       
    }, [props.orderDetail.accesories, RFCOrderDoc]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(props.orderDetail.remainingAmount <= 0.00)
        {
            setDisableOptions(false);
        }

    },[props.orderDetail])

    useEffect(() => {
        if (values.invoiceTypeOp.invoiceType !== undefined) {
            if (values.invoiceTypeOp.invoiceType === Constants.PurchaseInvoices.Rights) {
                let amount = parseFloat(values.rightAmount);
                if (Object.keys(values.right).length !== 0 && amount > 0) {
                    setDisabledButton(false);
                } else {
                    setDisabledButton(true);
                }
            } 
            else if (vinNotExist){
                if(vinValue !== "" && 
                    vehKeyValue !== "" &&
                    Object.keys(values.pdf).length !== 0 &&
                    Object.keys(values.xml).length !== 0){
                        setDisabledButton(false);
                    }
                else 
                    setDisabledButton(true);
            } 
            else if (
                Object.keys(values.pdf).length !== 0 &&
                Object.keys(values.xml).length !== 0 
            ) {
                setDisabledButton(false);
            } else {
                setDisabledButton(true);
            }
            setEnableFiles(false);
        } else {
            setDisabledButton(true);
            setEnableFiles(true);
        }
    }, [values]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setLoading(false);
    };

    const handleOpenBackdrop = () => {
        setLoading(true);
    };

    const InvoiceFilesCombination = () => {
        let invoiceOp;
        if (values.invoiceTypeOp.invoiceType.toString().substring(0,2) == 'NC')
            invoiceOp = "NC";
        else
            invoiceOp = values.invoiceTypeOp.invoiceType;
        switch (invoiceOp) {
            case "VE":
                values.documentType = "CARGO";
                values.chargeCode = "VECL";
                values.paymentType = "REGULAR";
                break;
            case "AC":
                values.documentType = "CARGO";
                values.chargeCode = "UACL";
                values.paymentType = "REGULAR";
                break;
            case "NC":
                values.documentType = "CREDITO";
                values.chargeCode = "VECL";
                values.paymentType = "CREDIT MEMO";
                break;
            case "TR":
                values.documentType = "CARGO";
                values.chargeCode = "USCL";
                values.paymentType = "REGULAR";
                break;
            default:
                break;
        }
    };

    const handleSubmit = (e) => {
         
        if (values.invoiceTypeOp.invoiceType !== "") {
            e.preventDefault();
            handleOpenBackdrop();
            InvoiceFilesCombination();
            const formData = new FormData();
            let invoiceOp;
            if (values.invoiceTypeOp.invoiceType.toString().substring(0,2) == 'NC')
                invoiceOp = "NC";
            else
                invoiceOp = values.invoiceTypeOp.invoiceType;
            formData.append("OrderId", props.orderId);
            formData.append("InvoiceType", invoiceOp);
            formData.append("DocumentType", values.documentType);
            formData.append("ChargeCode", values.chargeCode);
            formData.append("PaymentType", values.paymentType);
            formData.append("IsAccessory", values.isAccessory);
            formData.append("IsRight", values.isRight);
            formData.append("RightAmount", values.rightAmount);
            formData.append("ItemAffected", values.invoiceTypeOp.invoiceName.toString().split('-')[1]);
            formData.append("VIN", vinValue);
            formData.append("VehicleKey", vehKeyValue);
            formData.append("IdVehRelAcc", values.invoiceTypeOp.idVehRelAcc ?? 0);

            if (values.invoiceTypeOp.invoiceType === Constants.PurchaseInvoices.Rights) {
                for (let file of values.right) {
                    formData.append("Right", file);
                }
            } else {
                for (let file of values.pdf) {
                    formData.append("Pdf", file);
                }
                for (let file of values.xml) {
                    formData.append("Xml", file);
                }
            }
            props.purchaseActions.upload_invoice(
                props.userLanguage,
                props.userToken,
                values.orderId,
                formData,
                onError,
                onSuccess
            );
            setVinNotExist(false);
        } else {
            toast.error("Llenar todos los campos solicitados.", {
                className: classes.toastError,
            });
        }
    };

    const onSuccessDownload = (response) => {
        handleCloseBackdrop();
    };

    const onSuccessDetail = (response) => {

    }

const [allOptions, setAllOptions] = useState([]);

const onSuccessInvoiceType = (response) => {
  values.invoiceTypeOp = response;
 
  const formatted = response.map((item) => ({
    value: item.invoiceType,
    label: item.invoiceName,
    idAddFeat: item.afId,
    idVehRelAcc: item.vehRelAccId,
  }));
 
  setAllOptions(formatted);      
  setTypeSuggestions(formatted);
};

    const onSuccessInvoiceType0 = (response) => {
        values.invoiceTypeOp = response;
        //P2MSPFE-4482
        typeSuggestions0 = values.invoiceTypeOp.length > 0 ?
        values.invoiceTypeOp.map(item => ({ value: item.invoiceType, label: item.invoiceName, idAddFeat: item.afId, idVehRelAcc: item.vehRelAccId })) : [];
        //P2MSPFE-4482
    }

    const handleDownload = (documentId, documentType) => {
        handleOpenBackdrop();
        props.purchaseActions.download_document(
            "es-MX",
            props.userToken,
            onError,
            documentId,
            values.orderId,
            documentType,
            onSuccessDownload
        );
    };

    const handleDelete = (documentId, documentType) => {
        handleOpenBackdrop();
        if (documentType === "DERECHO")
            props.purchaseActions.delete_right(
                "es-MX",
                props.userToken,
                onError,
                documentId,
                values.orderId,
                onSuccessDeleteDocuments
            );
        else
        {
            props.purchaseActions.delete_invoice(
                "es-MX",
                props.userToken,
                onError,
                documentId,
                values.orderId,
                onSuccessDeleteDocuments
            );
        }
    };
    const invoiceTypeToRemove = "VE";   //P2MSPFE-4482
    const onSuccessDoc = (response) => {
        handleCloseBackdrop();
        props.purchaseActions.fetch_order_detail(
            props.userLanguage,
            props.userToken,
            values.orderId,
            onError,
            onSuccessDetail
        );
        if (response !== undefined || response !== null) {
            response.forEach((item) => {
                if (
                    item.invoiceType === "VE" &&
                    item.documentType === "text/xml" &&
                    (item.rfcInvoice !== undefined || item.rfcInvoice !== null)
                ) {
                    setRFCOrderDoc(item.rfcInvoice);
                }
            });      
            setDocs(response); //P2MSPFE-4482      
        }
    };

    const onSuccessHistory = (response) => {
        handleCloseBackdrop();
    };

    const onSuccessDeleteDocuments = () => {
        props.purchaseActions.fetch_order_detail(
            props.userLanguage,
            props.userToken,
            props.orderId,
            onError
        );
        props.purchaseActions.fetch_documents(
            props.userLanguage,
            props.userToken,
            values.orderId,
            onError,
            onSuccessHistory
        );
    };

    const onSuccess = (response) => {
        handleCloseBackdrop();
        if (response.status) {
            toast.success("Se agregó correctamente la factura", {
                className: classes.toastSuccess,
            });
            resetForm();
            ClearXML();
            ClearPDF();
        } else {
                toast.error("Ocurrió un error al validar la factura", {
                    className: classes.toastError,
                });
            setDisabledButton(false);
        }
        props.purchaseActions.fetch_invoice_errors(
            props.userLanguage,
            props.userToken,
            props.orderId,
            onError,
            onSuccessHistory
        );
        props.purchaseActions.fetch_documents(
            props.userLanguage,
            props.userToken,
            props.orderId,
            onError,
            onSuccessHistory
        );
        props.purchaseActions.fetch_order_detail(
            props.userLanguage,
            props.userToken,
            props.orderId,
            onError,
            onSuccessOrdrDtl
        );
    };

    const onSuccessOrdrDtl =()=>{}
    const onSuccessVIN = (response) => {
        handleCloseBackdrop();
        if (response.status) {
            if (response.errorValidators != null) {
                if (response.errorValidators == "El VIN no existe") {
                    setVinNotExist(true);
                    values.vinNotExist = true;
                    toast.warning("Favor de llenar manualmente campo VIN y Clave Vehicular");
                }
                else {
                    setVinNotExist(false);
                    values.vinNotExist = false;
                }
            }
            else {
                    setVinNotExist(false);
                    values.vinNotExist = false;
            }
        }
    };

    const ClearXML = () => {
        Array.from(document.querySelectorAll("div.fileXML > input")).forEach(
            (input) => (input.value = "")
        );
    };

    const ClearPDF = () => {
        Array.from(document.querySelectorAll("div.filePDF > input")).forEach(
            (input) => (input.value = "")
        );
    };
    
    const styleLbl = {
        color: '#FD7F20'
    }

    const onError = (err) => {
        handleCloseBackdrop();
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 400:
                    let temp = { ...errors };
                    var pdf =
                        err.response.data.errors.Pdf && err.response.data.errors.Pdf[0];
                    var xml =
                        err.response.data.errors.Xml && err.response.data.errors.Xml[0];
                    var invoiceType =
                        err.response.data.errors.InvoiceType &&
                        err.response.data.errors.InvoiceType[0];
                    var right =
                        err.response.data.errors.Right && err.response.data.errors.Right[0];
                    var rightAmount =
                        err.response.data.errors.RightAmount &&
                        err.response.data.errors.RightAmount[0];

                    if (pdf) {
                        temp.pdf = pdf;
                    }
                    if (xml) {
                        temp.xml = xml;
                    }
                    if (invoiceType) {
                        temp.invoiceType = invoiceType;
                    }
                    if (right) {
                        temp.right = right;
                    }
                    if (rightAmount) {
                        temp.rightAmount = rightAmount;
                    }

                    setErrors({
                        ...temp,
                    });
                    break;
                case 401:
                    props.tokenExpired();
                    history.push("/login");
                    break;
                case 403:
                    history.push("/forbidden");
                    break;
                case 500:
                    console.log(err.response.data);
                    break;
                default:
                    break;
            }
        }
    };

    const handleFileType = (event, type) => {
        switch (type) {
            case Constants.prefix.xml:
                if (handleGeneralFileTypes(event, Constants.prefix.xml)) {
                    handleInpuFileChange(event);
                    const formData = new FormData();
                    let invoiceOp;
                    if (values.invoiceTypeOp.invoiceType.toString().substring(0,2) == 'NC')
                        invoiceOp = "NC";
                    else
                        invoiceOp = values.invoiceTypeOp.invoiceType;
                    
                    formData.append("OrderId", props.orderId);
                    formData.append("InvoiceType", invoiceOp);
                    formData.append("Xml", event.target.files[0]);
                    XMLfile = event.target.files[0];
                    props.purchaseActions.validate_VIN(
                        props.userLanguage,
                        props.userToken,
                        values.orderId,
                        formData,
                        onError,
                        onSuccessVIN
                    );
                    setVinValue("");
                    setVehKeyValue("");
                } else {
                    toast.error("Formato no soportado", {
                        className: classes.toastError,
                    });
                    event.target.value = null;

                    let temp = { ...values };
                    temp.xml = {};
                    setValues(temp);
                }
                break;
            case Constants.prefix.pdf:
                if (handleGeneralFileTypes(event, Constants.prefix.pdf)) {
                    handleInpuFileChange(event);
                } else {
                    toast.error("Formato no soportado", {
                        className: classes.toastError,
                    });
                    event.target.value = null;

                    let temp = { ...values };
                    temp.pdf = {};
                    setValues(temp);
                }
                break;
            /*case Constants.prefix.right:
                if (handleGeneralFileTypes(event, Constants.prefix.right)) {
                    handleInpuFileChange(event);
                } else {
                    toast.error("Formato no soportado", {
                        className: classes.toastError,
                    });
                    event.target.value = null;

                    let temp = { ...values };
                    temp.right = {};
                    setValues(temp);
                }
                break;*/
            default:
                break;
        }
    };

    const handleInvoiceTab = (event, newValue) => {
        setInvoiceTab(newValue);
    };

    const handleChangeVIN = (e) => {
        setVinValue(e.target.value.replace(/[^a-zA-Z\d]/ig, ""));
        if(e.target.value !== "" && 
            vehKeyValue !== "" &&
            Object.keys(values.pdf).length !== 0 &&
            Object.keys(values.xml).length !== 0){
                setDisabledButton(false);
            }
        else 
            setDisabledButton(true);
    }

    const handleChangeVehKey = (e) => {
        setVehKeyValue(e.target.value.replace(/[^a-zA-Z\d]/ig, ""));
        if(e.target.value !== "" && 
            vinValue !== "" &&
            Object.keys(values.pdf).length !== 0 &&
            Object.keys(values.xml).length !== 0){
                setDisabledButton(false);
            }
        else 
            setDisabledButton(true);
    }

    const handleInvoiceType = (e) => {
        if (e.value === Constants.PurchaseInvoices.Rights) {
            setIsRight(true);
            values.isRight = true;
            setVinNotExist(false);
        } else if (e.value === Constants.PurchaseInvoices.Vehicle) {
            if(Object.keys(values.xml).length !== 0) {
                console.log("XML",Object.keys(values.xml).length);
                const formData = new FormData();
                    
                formData.append("OrderId", props.orderId);
                formData.append("InvoiceType", e.value);
                formData.append("Xml", XMLfile);
                    
                props.purchaseActions.validate_VIN(
                    props.userLanguage,
                    props.userToken,
                    values.orderId,
                    formData,
                    onError,
                    onSuccessVIN
                );
                setVinValue("");
                setVehKeyValue("");
            }
        } else {
            setIsRight(false);
            values.isRight = false;
            setVinNotExist(false);
        }
        
        values.invoiceTypeOp.invoiceType = e.value;
        values.invoiceTypeOp.invoiceName = e.label;
        values.invoiceTypeOp.afId = e.idAddFeat;
        values.invoiceTypeOp.idVehRelAcc = e.idVehRelAcc;
        
        handleInputChangeMS(e);
    };

useEffect(() => {
  if (!props.orderDetail?.accesories || !allOptions?.length) return;
 
  const accesoriesWithoutInvoice = props.orderDetail.accesories.filter(
    (acc) => acc.accesoryInvoice == null
  );
 
  const filteredOptions = allOptions
    .filter((item) => {
      if (props.orderDetail.invoiceDate != null && item.idAddFeat === 0) {
        return false;
      }
 
      if (item.idAddFeat === 0 && props.orderDetail.invoiceDate == null) {
        return true;
      }

      return accesoriesWithoutInvoice.some((acc) => acc.id === item.idAddFeat);
    })
    .map((item) => ({
      value: item.value,
      label: item.label,
      idAddFeat: item.idAddFeat,
      idVehRelAcc: item.idVehRelAcc,
    }));
 
  const isDifferent = JSON.stringify(filteredOptions) !== JSON.stringify(typeSuggestions);
 
  if (isDifferent) {
    setTypeSuggestions(filteredOptions);
  }
 
}, [props.orderDetail.accesories, props.orderDetail.invoiceDate, allOptions]);

    return (
        <div>
            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <div className={classes.rootTabPanel}>
                <Tabs
                    value={invoiceTab}
                    onChange={handleInvoiceTab}
                    indicatorColor="secondary"
                    textColor="secondary"
                    orientation="vertical"
                    variant="scrollable"
                    className={classes.tabsVertical}
                >
                    <Tab wrapped label="Factura" />
                    <Tab wrapped label="Historial de errores" />
                </Tabs>
                <TabPanel value={invoiceTab} index={0} style={{ display: "flex" }}>
                    <Grid container item xs={12} spacing={2}>
                        <Grid item xs={12}>
                            {
                                props.orderDetail &&
                                props.orderDetail.remainingAmount !== undefined && (
                                    <h6>
                                        Total restante: ${" "}
                                        {props.orderDetail.remainingAmount
                                            .toFixed(2)
                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                    </h6>
                                )
                            }
                            {
                                props.orderDetail &&
                                props.orderDetail.remainingAmount <= 0.00  &&
                                props.orderDetail.approvedInvoices === true && (
                                    <h6 style={styleLbl}>
                                        * No se pueden cargar o cambiar Facturas de Vehículo y Notas de Crédito.
                                    </h6>
                                )
                            }
                        </Grid>
                        <Grid item container spacing={2} xs={12}>
                            <Grid item xs={6}>
                                <FormControl
                                    fullWidth
                                    {...(errors.invoiceType && { error: true })}
                                >
                                    <InputLabel>Tipo de Factura</InputLabel>
                                    {/* <Select
                                        fullWidth
                                        name="invoiceType"
                                        value={typeSuggestions}
                                        onChange={(e) => handleInvoiceType(e)}
                                    >
                                        <MenuItem value="">
                                            <em>Ninguno</em>
                                        </MenuItem>
                                        {props.orderDetail.remainingAmount > 0.00 &&
                                        <MenuItem value={Constants.PurchaseInvoices.Vehicle}> 
                                            Vehículo
                                        </MenuItem>
                                        }
                                        {props.orderDetail.remainingAmount > 0.00  &&
                                        <MenuItem value={Constants.PurchaseInvoices.CreditNote}>
                                            Nota de crédito
                                        </MenuItem>
                                        }
                                        <MenuItem value={Constants.PurchaseInvoices.Collateral}>
                                            Gestoría
                                        </MenuItem>
                                        <MenuItem value={Constants.PurchaseInvoices.Transfer}>
                                            Traslado
                                        </MenuItem>
                                        <MenuItem value={Constants.PurchaseInvoices.Rights}>
                                            Derecho
                                        </MenuItem>
                                    </Select> */}
                                    {(props.orderDetail.remainingAmount > 0.00 )&&
                                    <CustomSelect                                 
                                        handleChange={handleInvoiceType}
                                        label='Tipo de Factura'
                                        options={typeSuggestions}
                                        placeholder='Seleccionar'
                                        value= {typeSuggestions.filter(p=> p.value==values.invoiceTypeOp.invoiceType)[0] || { label: 'Tipo de Factura', value: '' }} 
                                    />  
                                    }
                                    {props.orderDetail.remainingAmount <= 0.00 &&
                                    <CustomSelect  
                                        handleChange={handleInvoiceType}
                                        label='Tipo de Factura'
                                        options={typeSuggestions0}
                                        placeholder='Seleccionar'
                                        value= {typeSuggestions0.filter(p=> p.value==values.invoiceTypeOp.invoiceType)[0] || { label: 'Tipo de Factura', value: '' }} 
                                    />        
                                    }     
                                    <FormHelperText>
                                        {errors.invoiceType && errors.invoiceType}
                                    </FormHelperText>
                                </FormControl>
                            </Grid>
                            {!isRight ? (
                                <Grid item xs={6}></Grid>
                            ) : (
                                <Grid item xs={6}>
                                    <FormControl
                                        fullWidth
                                        {...(errors.rightAmount && { error: true })}
                                    >
                                        <InputLabel>{t("common.amount")}</InputLabel>
                                        <Input
                                            type="number"
                                            min={0}
                                            error={
                                                values.rightAmount < 0 || values.rightAmount === ""
                                            }
                                            name="rightAmount"
                                            value={values.rightAmount}
                                            onChange={handleInputChange}
                                            startAdornment={"$"}
                                            inputProps={{ pattern: "[0-9]*" }}
                                        />
                                        <FormHelperText>
                                            {errors.rightAmount && errors.rightAmount}
                                        </FormHelperText>
                                    </FormControl>
                                </Grid>
                            )}
                        </Grid>
                        {!isRight && (
                            <Grid item container spacing={2} xs={12}>
                                <Grid item xs={6}>
                                    <FormControl fullWidth {...(errors.xml && { error: true })}>
                                        <InputLabel>Archivo XML</InputLabel>
                                        <Input
                                            type="file"
                                            name="xml"
                                            id="xml"
                                            className="fileXML"
                                            onChange={(e) => handleFileType(e, Constants.prefix.xml)}
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    <InboxIcon />
                                                </InputAdornment>
                                            }
                                            disabled={enableFiles}
                                        />
                                        <FormHelperText>{errors.xml && errors.xml}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl fullWidth {...(errors.pdf && { error: true })}>
                                        <InputLabel>Archivo PDF</InputLabel>
                                        <Input
                                            type="file"
                                            name="pdf"
                                            id="pdf"
                                            className="filePDF"
                                            onChange={(e) => handleFileType(e, Constants.prefix.pdf)}
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    <InboxIcon />
                                                </InputAdornment>
                                            }
                                            disabled={enableFiles}
                                        />
                                        <FormHelperText>{errors.pdf && errors.pdf}</FormHelperText>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        ) /*: (
                            <Grid item container spacing={2} xs={12}>
                                <Grid item xs={6}>
                                    <FormControl fullWidth {...(errors.right && { error: true })}>
                                        <InputLabel>Derecho</InputLabel>
                                        <Input
                                            type="file"
                                            name="right"
                                            id="right"
                                            className="fileright"
                                            onChange={(e) =>
                                                handleFileType(e, Constants.prefix.right)
                                            }
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    <InboxIcon />
                                                </InputAdornment>
                                            }
                                        />
                                        <FormHelperText>
                                            {errors.right && errors.right}
                                        </FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}></Grid>
                            </Grid>
                        )*/
                        }
                        {vinNotExist && 
                            <Grid item container spacing={2} xs={12}>
                                <Grid item xs={6}>
                                    <FormControl fullWidth {...(errors.vinValue && { error: true })}>
                                        <InputLabel>VIN-Número de Serie</InputLabel>
                                        <Input
                                            type="text"
                                            name="vinValue"
                                            value={vinValue}
                                            onChange={handleChangeVIN}
                                            inputProps={{
                                                maxLength: 17
                                             }}
                                        />
                                        <FormHelperText>{errors.vinValue && errors.vinValue}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl fullWidth {...(errors.vehKeyValue && { error: true })}>
                                        <InputLabel>Clave Vehicular</InputLabel>
                                        <Input
                                            type="text"
                                            name="vehKeyValue"
                                            value={vehKeyValue}
                                            onChange={handleChangeVehKey}
                                            inputProps={{
                                                maxLength: 7
                                             }}
                                        />
                                        <FormHelperText>{errors.vehKeyValue && errors.vehKeyValue}</FormHelperText>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        }
                        <Grid item xs={12} className={classes.alignRight}>
                            <ButtonGroup
                                disableElevation
                                variant="contained"
                                size="small"
                                aria-label="small outlined button group"
                            >
                                <Button
                                    type="button"
                                    className={classes.ButtonSave}
                                    variant="outlined"
                                    onClick={handleSubmit}
                                    disabled={disabledButton}
                                >
                                    Guardar
                                </Button>
                            </ButtonGroup>
                        </Grid>
                        <Grid item xs={12}>
                            <hr />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                variant="body1"
                                component={"span"}
                                className={classes.alignLeft}
                            >
                                <Box fontWeight={600}>{t("purchaseDetail.otherInvoices")}</Box>
                            </Typography>
                            <DataTable
                                columns={getOtherInvoiceTableColumnSpa({
                                    handleDownload,
                                    handleDelete,
                                })}
                                data={props.orderDocuments.filter(
                                    (x) => x.invoiceType !== "AC"
                                )}
                                defaultSortField=""
                                noHeader={true}
                                customStyles={customStyleSecondary}
                                dense
                                responsive
                                striped
                                pointerOnHover
                                pagination
                                paginationComponentOptions={paginationOptions}
                                noDataComponent={
                                    <p className={classes.marginNoData}>
                                        {t("commonMessages.noData")}
                                    </p>
                                }
                            />
                        </Grid>
                        {
                            <Grid item xs={12}>
                                <Grid item xs={12} className={classes.subTitles}>
                                    <Typography variant="body1" style={{ fontWeight: 600 }}>
                                        {t("purchaseDetail.vehicleAccessories")}
                                    </Typography>
                                </Grid>
                                {arrayJSON && arrayJSON
                                        .map((item, index) => (
                                            (item.gift_accessory_ind == null || item.gift_accessory_ind == false) &&
                                            <div key={index}>
                                                <PurchaseUploadAccesoryInvoice
                                                    {...props}
                                                    accessory={item}
                                                />
                                            </div>
                                        ))}
                            </Grid>
                        }
                    </Grid>
                </TabPanel>
                <TabPanel value={invoiceTab} index={1}>
                    <Grid container item xs={12} spacing={2}>
                        <Grid item xs={12}>
                            <List component="nav">
                                {props.InvoiceErrors &&
                                    props.InvoiceErrors.map((item, index) => (
                                        <ListItem key={index}>
                                            <ListItemIcon>
                                                <InboxIcon />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={`${item.documentName} --- ${item.lastError}`}
                                            />
                                        </ListItem>
                                    ))}
                            </List>
                        </Grid>
                        <Grid item xs={12}>
                            <br />
                        </Grid>
                    </Grid>
                </TabPanel>
            </div>
            <ToastContainer />
        </div>
    );
};

const mapStateToProps = (state) => ({
    userProfile: state.UserProfileReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language,
    orderDocuments: state.PurchaseReducer.OrderDocuments,
    InvoiceErrors: state.PurchaseReducer.InvoiceErrors,
    orderDetail: state.PurchaseReducer.OrderDetail,
});

const mapDispatchToProps = (dispatch) => {
    return {
        tokenExpired: () => dispatch({ type: "TOKEN_EXPIRED" }),
        cleanUserProfile: () => dispatch({ type: "CLEAN_USER_PROFILE" }),
        purchaseActions: bindActionCreators(purchaseActions, dispatch),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(PurchaseStyles)(PurchaseUploadInvoice));
